import React, { useState } from "react";
import { apiClient, API } from "@/lib/auth";
import FinanceLayout from "./FinanceLayout";
import { FileText, Download, Loader2 } from "lucide-react";
import { toast } from "sonner";

const REPORTS = [
  { key: "pl",          title: "Profit & Loss",         subtitle: "Year-to-date income vs. approved expenses, categorized",   path: "/finance/reports/pl.pdf",           file: "TEA-PL.pdf" },
  { key: "k1",          title: "K-1 Summary",           subtitle: "CPA-ready member share summary (not IRS-filed)",           path: "/finance/reports/k1-summary.pdf",   file: "TEA-K1-Summary.pdf" },
  { key: "tax-package", title: "Full Tax Package",      subtitle: "P&L + K-1 summary + cover letter for your CPA",            path: "/finance/reports/tax-package.pdf",  file: "TEA-Tax-Package.pdf" },
];

const ReportsPage = () => {
  const [busy, setBusy] = useState(null);
  const year = new Date().getFullYear();

  const download = async (r) => {
    setBusy(r.key);
    try {
      // We hit /api backend directly with the JWT bearer, get the PDF blob, then trigger a browser download.
      const token = localStorage.getItem("nex_token");
      const res = await fetch(`${API}${r.path}?year=${year}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error(`Server returned ${res.status}`);
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = r.file.replace(".pdf", `-${year}.pdf`);
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${r.title} downloaded`);
    } catch (err) {
      toast.error(`Download failed: ${err.message}`);
    } finally {
      setBusy(null);
    }
  };

  return (
    <FinanceLayout>
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <FileText size={20} className="text-nex-gold" />
          <div className="mono-label">// PDF EXPORTS</div>
        </div>
        <h1 className="serif-head text-3xl">Reports · {year}</h1>
        <p className="text-nex-chrome mt-2 text-sm">
          One-click PDF exports for your CPA. Every report pulls from the live ledger — regenerate anytime.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-4" data-testid="reports-grid">
        {REPORTS.map((r) => (
          <div key={r.key} className="card-industrial corner-tick p-6 flex flex-col" data-testid={`report-card-${r.key}`}>
            <FileText size={22} className="text-nex-gold mb-4" />
            <h2 className="serif-head text-xl mb-2">{r.title}</h2>
            <p className="text-nex-chrome text-sm flex-1">{r.subtitle}</p>
            <button
              onClick={() => download(r)}
              disabled={busy === r.key}
              className="tick-btn-primary text-xs !py-2 !px-4 mt-4 justify-center"
              data-testid={`download-${r.key}`}
            >
              {busy === r.key ? <><Loader2 size={13} className="animate-spin" /> Generating</> : <><Download size={13} /> Download PDF</>}
            </button>
          </div>
        ))}
      </div>

      <div className="mt-8 mono-body text-[11px] text-nex-muted text-center">
        Reports are generated server-side using ReportLab. Ownership: 50/50 · LIFE LLC (partnership).
      </div>
    </FinanceLayout>
  );
};

export default ReportsPage;
